import { Routes } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';
import { AboutComponent } from './pages/about/about.component';
import { RoadmapComponent } from './pages/roadmap/roadmap.component';
import { HomeComponent } from './pages/home/home.component';
import { OfferingPageComponent } from './pages/offering/offering-page.component';
import { FocusMyOfferingsComponent } from './components/focus/focus-my-offerings/focus-my-offerings.component';
import { FocusApplicationFormComponent } from './components/focus/focus-application-form/focus-application-form.component';
import { FocusKnowledgeFormComponent } from './components/focus/focus-knowledge-form/focus-knowledge-form.component';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { authGuard } from './guards/auth.guard';
import { featureFlagGuard } from './guards/feature-flag.guard';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { FocusInfrastructureFormComponent } from './components/focus/focus-infrastructure-form/focus-infrastructure-form.component';
import { FocusPlatformFormComponent } from './components/focus/focus-platform-form/focus-platform-form.component';
import { MercuryFormComponent } from './components/panorama/mercury-form/mercury-form.component';
import { CatalogFormComponent } from './components/panorama/catalog-form/catalog-form.component';
import { FocusDashboardComponent } from './components/focus/focus-dashboard/focus-dashboard.component';
import { FocusServiceFormComponent } from './components/focus/focus-service-form/focus-service-form.component';
import { FocusFormManagerComponent } from './components/focus/focus-form-manager/focus-form-manager.component';
import { AssistantPageComponent } from './pages/assistant/assistant-page.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'focus',
    component: FocusDashboardComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'my-offerings',
        pathMatch: 'full',
      },
      {
        path: 'my-offerings',
        component: FocusMyOfferingsComponent,
      },
      {
        path: 'form-manager',
        component: FocusFormManagerComponent,
      },
      {
        path: 'offering/application',
        component: FocusApplicationFormComponent,
      },
      {
        path: 'offering/application/:uuid',
        component: FocusApplicationFormComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'offering/infrastructure',
        component: FocusInfrastructureFormComponent,
      },
      {
        path: 'offering/infrastructure/:uuid',
        component: FocusInfrastructureFormComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'offering/platform',
        component: FocusPlatformFormComponent,
      },
      {
        path: 'offering/platform/:uuid',
        component: FocusPlatformFormComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'offering/professional-service',
        component: FocusServiceFormComponent,
      },
      {
        path: 'offering/professional-service/:uuid',
        component: FocusServiceFormComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'knowledge/:uuid',
        component: FocusKnowledgeFormComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'knowledge',
        component: FocusKnowledgeFormComponent,
      },
    ],
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [authGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [authGuard],
  },
  {
    path: 'roadmap',
    component: RoadmapComponent,
    canActivate: [authGuard],
  },
  {
    path: 'offerings/:name',
    component: OfferingPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'search',
    component: SearchResultComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mercury-form/:id',
    component: MercuryFormComponent,
    canActivate: [authGuard],
  },
  {
    path: 'catalog-form/:sysId',
    component: CatalogFormComponent,
    canActivate: [authGuard],
  },
  {
    path: 'assistant',
    component: AssistantPageComponent,
    canActivate: [authGuard, featureFlagGuard],
    data: { featureFlag: 'panorama_inexp_2498_assistant' },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
